import { Component, Input, OnInit, OnChanges, EventEmitter, Output } from '@angular/core'
import { PublicTimelineItem, PublicEventInfo } from 'globals/store/public.model'
import { flatten, getNestedSet, makeProgramText } from 'globals/helpers/helpers';
import { LabelSelectorDialog } from './label-selector.dialog';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { MatDialog } from '@angular/material/dialog';
import { ProgramTab, getDefaultProgramTabNames } from 'globals/store/share.data';
import { JoiFile } from 'globals/store/files.model';
import publicHelpers from 'globals/helpers/public-helpers';
import { Label, Venue } from 'globals/store/events.data';
import { Subject } from 'rxjs';
import { findTimeZone } from 'timezone-support';
import { BrandOption, BrandingData, HomePageData, getSelectableLabelGroups } from 'globals/store/publish.data';
import { loadProgramTexts } from 'globals/store/programs.data';
import { LabelSelectorData, SelectableLabelGroup } from 'globals/store/dialog.selector.data';
import { IconComponent } from '../icon/icon.component';
import { BrandingWrapperComponent } from '../branding/branding-wrapper.component';
import { IconTextComponent } from '../buttons/icon-text.component';
import { PublishTimelineViewComponent } from './publish-timeline-view.component';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { CallsToActionComponent } from '../branding/branding-ctas.component';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { SharedTimelineComponent } from '../wrappers/shared-timeline-wrapper.component';
import { AppIconComponent } from 'src/app/modules/app/app-icon.component';
import { HomePageComponent } from '../branding/home-page.component';
import { PerformerGalleryComponent } from 'src/app/modules/performers/performer-gallery.component';
import { SponsorGalleryComponent } from 'src/app/modules/sponsors/sponsor-gallery.component';
import { ExhibitorGalleryComponent } from 'src/app/modules/exhibitors/exhibitor.gallery.component';

@Component({
    selector: 'publish-timeline',
    templateUrl: './publish-timeline.html',
    styleUrls: ['publish-timeline.scss'],
    standalone: true,
    imports: [IconComponent, PublishTimelineViewComponent, SponsorGalleryComponent, ExhibitorGalleryComponent, PerformerGalleryComponent, MatSelectModule, SharedTimelineComponent, CallsToActionComponent, JoiNavWrapper, AppIconComponent, HomePageComponent, CommonModule, BrandingWrapperComponent, IconTextComponent],
})
export class PublishTimelineComponent implements OnInit, OnChanges {

  timeline!: PublicTimelineItem[][]
  @Input() data!: PublicTimelineItem[][]
  @Input() breakDays = false
  @Input() madeWithJoi: boolean = false
  @Input() fromShare = false
  @Input() joiEvent!: PublicEventInfo;
  @Input() title: string = ''
  @Input() CTALinks: JoiFile[] = []
  @Input() venue: Venue = {} as Venue
  @Input() loading: boolean = false;
  @Input() excludedFieldIds: string[] = []
  @Input() isConfigure = false
  @Input() isPreview = false
  @Input() isApp = false
  @Input() version: number = 0
  @Input() tabNames: { [tId: string]: string } = {}
  @Input() brandingData!: BrandingData
  @Input() homePageData!: HomePageData
  @Output() change: EventEmitter<BrandOption> = new EventEmitter()
  
  $toggleAll: Subject<boolean> = new Subject();

  defaultTabNames = getDefaultProgramTabNames() 
  tabIcons:{ [tId in ProgramTab]: string } = {
    homeTab: 'HOME',
    sponsorsTab: 'SPONSOR24',
    performersTab: 'PERFORMERS24',
    programTab: 'PROGRAM24',
    exhibitorsTab: 'EXHIBITORS_24'
  }

  programTexts = {}
  PROGRAM = 'programTab'
  PERFORMERS = 'performersTab'
  SPONSORS = 'sponsorsTab'
  EXHIBITORS = 'exhibitorsTab'
  HOME = 'homeTab'
  defaultMenu = [this.HOME, this.PROGRAM, this.PERFORMERS, this.SPONSORS, this.EXHIBITORS]
  tabsMenu = this.defaultMenu
  selectedTab = this.HOME
  extraFiltersIds: Set<string> = new Set()
  extraExhibitorsFiltersIds: Set<string> = new Set()
  labelGroups: SelectableLabelGroup[] = []
  exhibitorLabelGroups: SelectableLabelGroup[] = []
  publicHelpers = publicHelpers
  userSelectedTimezone: any | null = null;
  deviceTimezone: string = '';
  viewMyTimezone = false;
  deviceTimezoneEqualsAllProgramTimezones = true;
  constructor(private dialog: MatDialog) {}

  ngOnInit() { 
    this.deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // console.log({ deviceTimezone: this.deviceTimezone })
    // setTimeout(() => console.log(this.data), 2000)
    // this.userTimezoneSelectionOptions = listTimeZones();
  }

  expandAll() {
    this.$toggleAll.next(true)
  }

  collapseAll() {
    this.$toggleAll.next(false)
  }

  hasTabEntities(tab: string) {
    if (!this.joiEvent) return false
    switch(tab) {
      case this.PERFORMERS:
        return this.joiEvent.profilePerformers && Object.values(this.joiEvent.profilePerformers).length
      case this.SPONSORS:
        // console.log({ profileSponsors: this.joiEvent.profileSponsors })
        return this.joiEvent.profileSponsors && Object.values(this.joiEvent.profileSponsors).length
      case this.EXHIBITORS:
        // console.log({ profileExhibitors: this.joiEvent.profileExhibitors })
        return this.joiEvent.profileExhibitors && Object.values(this.joiEvent.profileExhibitors).length
      default:
        return true
    }
  }

  getMenu() {
    this.tabsMenu = this.defaultMenu.filter(tab => (!this.excludedFieldIds || !this.excludedFieldIds.includes(tab)))
    // console.log({ deviceTimezone: this.deviceTimezone, timeline: this.timeline,  defaultMenu: this.defaultMenu, tabsMenu: this.tabsMenu, excludedFieldIds: this.excludedFieldIds })
    if (!this.selectedTab || !this.tabsMenu.includes(this.selectedTab)) this.selectedTab = this.tabsMenu[0] // could be undefined but that's okay
  }

  
  async openExtraFilters(isMobile: Boolean, type: 'program' | 'exhibitor') {
    const el: HTMLElement | null = document.getElementById(`filterIcon${isMobile ? 'Mobile' : ''}`)
    if (!el) return
    const rect = el.getBoundingClientRect()
    const { bottom, right, x } = rect
    const data: LabelSelectorData = {
      isMobile: this.fromShare,
      // tslint:disable-next-line:max-line-length
      instructions: !this.isPreview ? undefined : `Note: This label filter is part of the published ${type === 'program' ? 'program page' : 'exhibitors page'} that users can control.  Any filter applied here will not be saved when you publish.\n\nTo adjust what is displayed in your published ${type === 'program' ? 'program page' : 'exhibitors page'}, use the <b>Display Options</b> or <b>Filter Timeline</b> controls.`,
      position: { left: right - 290, top: bottom + 4 },
      labelGroups: type === 'program' ? this.labelGroups : this.exhibitorLabelGroups,
      template: this.brandingData.template
    }
    console.log({ data })
    const labels: SelectableLabelGroup[] = await openDialogGetResult<SelectableLabelGroup[]>(this.dialog, LabelSelectorDialog, { width: '290px', disableClose: false, autoFocus: false, data, backdropClass: 'clear' })
    const newIds = new Set(labels[0].labels.filter(l => l.selected).map(l => l.id))
    if (type === 'program') this.extraFiltersIds = newIds
    else this.extraExhibitorsFiltersIds = newIds
    this.loadTimeline()
  }

  trackByIndex(index: any) {
    return index
  }

  selectTab(selectedTab: string) {
    // console.log({ selectedTab});
    this.selectedTab = selectedTab
    this.scrollUp()
  }

  scrollUp() {
    if (this.fromShare && document.querySelector("html") !== null) {
      const html = document.querySelector("html");
      if(html) html.scrollTo(0,0)
    }else setTimeout(() => {
      const scrollableWrapper = document.querySelector("scrollable-wrapper");
      if (scrollableWrapper !== null) scrollableWrapper.scrollTo(0,0);
    }, 0)
  }

  ngOnChanges(changes:any) {
    setTimeout(() => {
      this.loadFilters()
      this.loadTimeline()
      this.loadProgramTexts()
      this.loadTimezone()
    }, 0)
    this.getMenu()
  }

  loadFilters() {
    if (!this.data || !this.joiEvent) return
    const { session_labels, exhibitor_labels, profileExhibitors } = this.joiEvent
    if (session_labels) {
      const sessionLabelIds: Set<string> =  new Set((this.data as any).flat().map((s: PublicTimelineItem )=> s.labels).filter((l: Label) => l).flat())
      this.labelGroups = getSelectableLabelGroups(sessionLabelIds, session_labels)
    }
    if (exhibitor_labels && this.joiEvent.profileExhibitors) {
      const exhibitorLabelIds = new Set(flatten(Object.values(profileExhibitors).map(e => e.labels || [])))
      this.exhibitorLabelGroups = getSelectableLabelGroups(exhibitorLabelIds, exhibitor_labels)
    }

  }

  loadTimeline() {
    if (!this.data) return
    if (!this.extraFiltersIds.size) {
      this.timeline = this.data
    } else {
      this.timeline = []
      for (let i = 0; i < this.data.length; i++) {
        const day = this.data[i].filter(session => session.labels && session.labels.some(l => this.extraFiltersIds.has(l)))
        if (day.length) this.timeline.push(day)
      }
    }
  }

  loadProgramTexts() {
    if (!this.data) return
    this.programTexts = loadProgramTexts(this.data, this.excludedFieldIds, this.joiEvent?.venues)
  }

  viewMyTimezoneToggle() {
    this.viewMyTimezone = !this.viewMyTimezone;
    this.setUserSelectedTimezoneTo(this.deviceTimezone);
  }

  setUserSelectedTimezoneTo(timezoneString:string){
    const timezone = findTimeZone(timezoneString);
    // console.log({ timezone })
    this.userSelectedTimezone = this.viewMyTimezone ? timezone : null;
    return timezone;
  }
  

  loadTimezone(timezoneName?: string){ // this can be refactored when we decide on timezone being a dropdown or button
    const timezone = this.setUserSelectedTimezoneTo(timezoneName || this.deviceTimezone);
    const timeline = this.timeline || []
    const programTimezoneAbbrs = ([] as PublicTimelineItem[]).concat(...timeline).map((session: PublicTimelineItem) => session.timezoneAbbr).filter((abbr, i, arr) => arr.indexOf(abbr) === i )
    const abbrsDeviceHas = programTimezoneAbbrs.filter((abbr) => (timezone as any)?.abbreviations?.includes(abbr)); // TimeZoneInfo as a type has no property "abbreviations".  Cannot compile without setting to any
    this.deviceTimezoneEqualsAllProgramTimezones = programTimezoneAbbrs.length === abbrsDeviceHas.length;
  }
}
